
@if (selectUserFormControl.invalid && selectUserFormControl.dirty) {
    <c11n-banner
            [hasCloseControl]="false"
            [size]="'small'"
            [variant]="'error'"
            class="c11n-space-stack-3x"
            data-cy="select-user-error-banner"
            role="alert"
    >
        <div
                class="c11n-text-md--crop"
        >
            {{ content.removeAccessFlow.selectUser.validationMessage.required }}
        </div>
    </c11n-banner>
}

@if (isInternal) {
    <c11n-internal-callout class="c11n-space-stack-3x">
        <p class="c11n-text-md c11n-link--reinforced">
            {{ infowaveBoxContents[0] }} <a
                [href]="infoWaveUrl"
                [variant]="'secondary-reinforced'"
                c11n-link
                class="c11n-link pointer"
                tabindex="0"
                target="_blank">Infowave</a>
            {{ infowaveBoxContents[1] }}
        </p>
    </c11n-internal-callout>
}

<div class="c11n-space-stack-2x custom-radio-style">
    <c11n-radio-group
            [formGroup]="selectUserFormGroup"
            [groupId]="radioGroupId"
            [hideLegend]="true"
            [legendText]="content.removeAccessFlow.selectUser.title"
            [variant]="'tiles'"
    >
        <c11n-radio
                *ngFor="let user of users$ | async; index as i"
                [focusLabel]="false"
                [labelText]="constructUserName(user)"
        >
            <input
                    (change)="onUserSelect(user)"
                    [attr.user-access-level]="user.accessLevel"
                    [formControlName]="selectUserFormControlName"
                    [name]="selectUserFormControlName"
                    [value]="user"
                    c11nRadioInput
                    type="radio"
            />
        </c11n-radio>
    </c11n-radio-group>
</div>

<!-- Below modal appears when some select user via radio button from the list for removing full access for all types of clients( PI, WM and UNKNOWN) -->
<c11n-modal-dialog-entrypoint></c11n-modal-dialog-entrypoint>
<c11n-modal-dialog
    #selectUserModalDialogue
    (primaryClick)="quit()"
    [headingText]="grantorContent.edit_remove_user_access.removeThisPersonContactInfo.heading"
    [maxWidth]="660"
    [primaryButtonLabel]="
        grantorContent.edit_remove_user_access.removeThisPersonContactInfo.okButton
    "
    [useContentWidth]="false"
    [variant]="'basic'"
    data-cy="select-user-modal"
>
    <div c11n-modal-dialog-body>
        <div class="c11n-text-md c11n-space-stack-6x" data-cy="accessModal">
            <p>{{ errDescription }}</p>
            <br/>
            <p>{{ grantorContent.edit_remove_user_access.ttyTddContactInfo }}</p>
        </div>
    </div>
</c11n-modal-dialog>
